/**
 * UranIA PA — `/onboarding` (wizard unico, si adatta al ruolo).
 *
 * Fusione A.4.3 (Riordino della mappa delle rotte §3/§4): "il ruolo è
 * nel token, metterlo anche nell'URL crea due verità." Non un merge dei
 * form — i campi PA e R&I restano completamente diversi (vedi
 * `onboarding/pa.tsx` / `onboarding/ri.tsx`) — ma un'unica URL che
 * sceglie quale dei due wizard mostrare in base al ruolo del principal
 * autenticato, invece di due URL che l'utente doveva già sapere
 * distinguere da solo. `/onboarding/pa` e `/onboarding/ri` restano come
 * redirect qui.
 *
 * platform_admin / tenant_admin non hanno un profilo da onboardare
 * (nessuno dei due form li riguarda): chi ci arriva senza un ruolo
 * riconosciuto torna a `/servizi`, non vede uno dei due wizard a caso.
 */

import { createRoute, Link } from '@tanstack/react-router';
import type { JSX } from 'react';

import { selectPrincipal, useAuthStore } from '../../lib/auth/auth-store.ts';
import { principalIsBeneficiario, principalIsFunzionario } from '../../lib/auth/rbac.ts';
import { Route as ServiziSegmentRoute } from '../_servizi.tsx';
import { OnboardingPaPage } from './pa.tsx';
import { OnboardingRiPage } from './ri.tsx';

function OnboardingRoutedPage(): JSX.Element {
  const principal = useAuthStore(selectPrincipal);

  if (principalIsFunzionario(principal)) {
    return <OnboardingPaPage />;
  }
  if (principalIsBeneficiario(principal)) {
    return <OnboardingRiPage />;
  }
  return <OnboardingUnavailable />;
}

function OnboardingUnavailable(): JSX.Element {
  return (
    <section className="urania-onboarding-unavailable" data-testid="onboarding-unavailable">
      <div className="alert alert-info" role="region">
        <p className="mb-0">
          Il tuo ruolo non prevede un profilo da completare qui.{' '}
          <Link to="/servizi">Torna ai servizi</Link>.
        </p>
      </div>
    </section>
  );
}

export const Route = createRoute({
  getParentRoute: () => ServiziSegmentRoute,
  path: '/onboarding',
  component: OnboardingRoutedPage,
});
